import OaDivider from '@orientaction/commons/OaDivider';
import { AdminTestContext } from '@orientaction/Context';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import FinalTextSection from './FinalTextSection';
import QuestionsSection from './QuestionsSection';
import RecommendedTestsSection from './RecommendedTestsSection';
import TestMainInfo from './TestMainInfo';
import Title from './Title';
import VariablesSection from './VariablesSection';
import VisibilitySection from './VisibilitySection';
import AglomerationSection from './AglomerationSection';

const CreateTestForm = () => {
  const { test } = useContext<any>(AdminTestContext);
  const {
    testTitleRef,
    testImageRef,
    testTimeRef,
    testVisibilityRef,
    testMinMaxValueRef,
    testGlobalTimerRef,
  } = test?.refs;


  return (
    <DndProvider backend={HTML5Backend}>
      <Title />
      <TestMainInfo
        ref={
          {
            titleRef: testTitleRef,
            imageRef: testImageRef,
          } as any
        }
      />
      <VisibilitySection
        ref={
          {
            timeRef: testTimeRef,
            visibilityRef: testVisibilityRef,
            testMinMaxValueRef,
            globalTimerRef: testGlobalTimerRef,
          } as any
        }
      />
      <OaDivider />
      {test?.test?.diagram?.id === 6 ? <AglomerationSection /> : <VariablesSection />}
      {test?.test?.diagram?.id !== 6 && <OaDivider />}
      {test?.test?.diagram?.id !== 6 && <QuestionsSection />}

      <RecommendedTestsSection />
      <OaDivider />
      <FinalTextSection />
    </DndProvider>
  );
};

export default CreateTestForm;
